import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { AsyncActionStatus } from '../../actions/common.actionTypes';
import { routes } from '../../constants';
import { getMeStatus, selectIsAuthenticated, selectUser } from '../../reducers/user.selectors';
import useRouter from '../../utils/useRouter';

interface RedirectIfLoggedInProps {
  basisUserRedirectTo?: string;
  children?: React.ReactNode;
}

const RedirectIfLoggedIn: React.FC<RedirectIfLoggedInProps> = (props) => {
  const { basisUserRedirectTo } = props;
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const userStatus = useSelector(getMeStatus);
  const user = useSelector(selectUser);
  const { router } = useRouter();

  const redirectTarget = useMemo(() => {
    if (!isAuthenticated || !user) {
      return undefined;
    }

    if (basisUserRedirectTo && (user.isBasisUser || user.isCourseUser)) {
      return basisUserRedirectTo;
    }

    if (user.isAiOnlyUser) {
      return `/${routes.aiTools.root}`;
    }

    return `/${routes.dashboard.root}`;
  }, [basisUserRedirectTo, isAuthenticated, user]);

  useEffect(() => {
    if (redirectTarget) {
      router.replace(redirectTarget);
    }
  }, [redirectTarget, router]);

  if (isAuthenticated) {
    if (basisUserRedirectTo && userStatus !== AsyncActionStatus.READY) {
      return <></>;
    }
    return <></>;
  }

  return (
    <>
      {props.children}
    </>
  );
};

export default RedirectIfLoggedIn;
